module.exports = __webpack_public_path__ + "static/content_3_1_do-d5e7f0b25a76b03cee80ade7c04b0f2a.png";